import { Col, Row, message } from 'antd';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { assignToGroups } from '../../../api/groups';
import {
  createUser,
  fetchUsers,
  sendUpdateAccountEmail,
} from '../../../api/users';
import { AddUserForm } from '../../../components';
import { UserDetails } from '../../../constants/types';
import { formatErrorMessage } from '../../../utils/errorMessage';
import { getParentOrigin } from '../../../utils/getKeycloakConfig';
import { Title } from '../../styles';

const makePayload = (userDetails: any) => {
  const basicInfo = {
    username: userDetails.email,
    email: userDetails.email,
    firstName: userDetails.firstName,
    lastName: userDetails.lastName,
    enabled: true,
  };

  let payload: UserDetails = basicInfo;

  if (userDetails.configure_totp) {
    payload.requiredActions = ['CONFIGURE_TOTP'];
  }

  if (
    userDetails.account_end_date &&
    moment(userDetails.account_end_date).isValid()
  ) {
    payload['attributes'] = {
      account_end_date: moment(userDetails.account_end_date).valueOf(),
    };
  } else {
    payload['attributes'] = {
      account_end_date: null,
    };
  }

  if (userDetails.action === 'createCredentials') {
    payload = {
      ...basicInfo,
      credentials: [
        {
          type: 'password',
          value: userDetails.password,
          temporary: true,
        },
      ],
    };
  }
  return payload;
};

const CreateUser = () => {
  const history = useHistory();
  const intl = useIntl();
  const parentOrigin = getParentOrigin();

  const onUserSuccess = async (userId: any, userDetails: any) => {
    if (userDetails.groups?.length > 0) {
      userDetails.groups.forEach(async (groupId: string) => {
        await assignToGroups(userId, groupId);
      });
    }
    if (userDetails.action === 'sendInvitationLink') {
      await sendUpdateAccountEmail(userId);
    }
    message.success(
      intl.formatMessage(
        {
          id: 'User.successfullyAdded',
        },
        {
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
        },
      ),
      2,
    );

    if (parentOrigin && window.top && window.top !== window) {
      window.top.postMessage(
        {
          type: 'redirect',
          url: `/admin/users?newUser=${userId}`,
        },
        parentOrigin,
      );
    } else {
      history.push(`/users?newUser=${userId}`);
    }
  };

  const onSubmit = async (userDetails: any) => {
    const payload = makePayload(userDetails);
    try {
      await createUser(payload);
      const user = await fetchUsers(`&email=${userDetails.email}`);
      const userId = user[0].id;
      if (userId) {
        await onUserSuccess(userId, userDetails);
      }
      return userId;
    } catch (error: any) {
      if (error.status !== 409) {
        const errorMessage =
          error.data.error_description ||
          error.data.error ||
          error.data.errorMessage ||
          '';
        const formatedError = formatErrorMessage(errorMessage);
        message.error(formatedError, 2);
      }
      return null;
    }
  };

  return (
    <>
      <Row justify="center" style={{ paddingTop: '28px' }}>
        <Col lg={14} md={18} sm={24} style={{ padding: '20px 30px' }}>
          <Title data-testid="create-user-title">
            <FormattedMessage id="User.newUser.btn" />
          </Title>
          <AddUserForm onSubmit={onSubmit} />
        </Col>
      </Row>
    </>
  );
};

export default CreateUser;
